module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-left": "-28px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-tips"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v("绑定商家电话设置")]), _vm._v(" "), _c('span', [_vm._v("(只有已绑定的电话才有权限验证)")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover bound-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.phones), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.unbindPhone(item)
        }
      }
    }, [_vm._v("撤销绑定")])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticStyle: {
      "width": "250px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.bindPhone()
      }
    }
  }, [_vm._v("进行绑定")])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("美团门票验证电话")]), _vm._v(" "), _c('p', {
    staticClass: "telephone"
  }, [_vm._v("400-660-1065")]), _vm._v(" "), _c('p', {
    staticClass: "telephone-tips"
  }, [_vm._v("1，按 \"3\" 进入验证功能")]), _vm._v(" "), _c('p', {
    staticClass: "telephone-tips"
  }, [_vm._v("2，再按 \"2\" 进入旅游门票验证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-thead"
  }, [_c('span', {
    staticClass: "tip-status",
    staticStyle: {
      "margin-left": "5px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("绑定的电话可以是固话或手机号，固话请加区号，录入纯数字不加’-‘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("绑定电话")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a06f7a1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/phone/pages/phoneVerify.vue
// module id = 598
// module chunks = 0